import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useParams } from "react-router-dom"
import { TroubleReport } from "../../templates/TroubleReport"
import { callRequestCreateOperationTroubleWithUploadedPictures } from "../../hooks/useTroubles"
import { assertIsDefined } from "@/utils/assetIsDefined"
import { genOperationReportPagePath } from "@/routes/protected"

export const TroubleReportPage = () => {
    const { operationId } = useParams<"operationId">()
    assertIsDefined(operationId)
    const pathToNavigate = genOperationReportPagePath(
        operationId,
        "troubles/next"
    )

    const { token } = useAuth()
    return (
        <TroubleReport
            operationId={operationId}
            skippable={true}
            troubleReportedPath={pathToNavigate}
            onSubmit={input =>
                callRequestCreateOperationTroubleWithUploadedPictures(
                    token,
                    operationId,
                    input
                )
            }
        />
    )
}
